import React from "react";

export default function LifecycleGraph({ graph }) {

  if (!graph || !graph.edges || graph.edges.length === 0) {
    return (
      <div className="lifecycle-graph">
        <h3>Lifecycle Graph</h3>
        <p>No lifecycle flow found.</p>
      </div>
    );
  }

  const handleNodeClick = (nodeId) => {
    console.log("Node clicked:", nodeId);

    // Future navigation logic
    // Example:
    // if(nodeId.startsWith("PO")) navigate(`/procurement/po/${nodeId}`)
    // if(nodeId.startsWith("GRN")) navigate(`/procurement/grn/${nodeId}`)
  };

  return (

    <div className="lifecycle-graph">

      <h3>Lifecycle Graph</h3>

      <div className="lifecycle-flow">

        {graph.edges.map((edge, index) => (

          <div className="lifecycle-flow-row" key={index}>

            <div
              className="flow-node node-po"
              onClick={() => handleNodeClick(edge.from)}
            >
              {edge.from}
            </div>

            <div className="flow-arrow">
              →
            </div>

            <div
              className="flow-node node-grn"
              onClick={() => handleNodeClick(edge.to)}
            >
              {edge.to}
            </div>

          </div>

        ))}

      </div>

    </div>

  );

}